export const PAGE_VIEW = 'analytics/PAGE_VIEW';
export const UPDATE_FIELD = 'analytics/UPDATE_FIELD';
export const PREVIEW_CLICK = 'analytics/PREVIEW_CLICK';
export const CANT_FIND_COMPANY = 'analytics/CANT_FIND_COMPANY';
export const VIDEO_STATUS = 'analytics/VIDEO_STATUS';
export const VIEW_ONBOARDING = 'analytics/VIEW_ONBOARDING';
export const VIEW_PROFILE = 'analytics/VIEW_PROFILE';
export const VIEW_PROFILE_LIST = 'analytics/VIEW_PROFILE_LIST';
export const VIEW_EDIT_PROFILE = 'analytics/VIEW_EDIT_PROFILE';
export const VIEW_EDIT_IMAGE = 'analytics/VIEW_EDIT_IMAGE';
export const VIEW_STATISTICS = 'analytics/VIEW_STATISTICS';
export const VIEW_SETTINGS = 'analytics/VIEW_SETTINGS';
export const EDIT_CLICK = 'analytics/EDIT_CLICK';
export const VIEW_IMAGE = 'analytics/VIEW_IMAGE';
export const SHOW_MORE_IMAGES = 'analytics/SHOW_MORE_IMAGES';
export const CLICK_ACTIVE_AD = 'analytics/CLICK_ACTIVE_AD';
export const EXPAND_AMBASSADORS = 'analytics/EXPAND_AMBASSADORS';
export const REVEAL_AMBASSADORS = 'analytics/REVEAL_AMBASSADORS';

export default function analytics(type, args) {
    return {
        type,
        ...args,
    };
}
